import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { BASE_THEME_IDS } from '../constants';
import { TYPOGRAPHY_BASE } from './BaseTypography';
import { BREAKPOINTS_BASE, BREAKPOINTS_BASE_EM, BREAKPOINTS_BASE_EM_MIN_WIDTH_MEDIA_QUERY, DEFAULT_BREAKPOINTS_ASC_BASE } from './BaseBreakpoints';
import { MARGINS_BASE } from '../styling/margins';
import { queryParams } from '../utils';
import { SHARED_VARIABLES_REFERENCE_OBJECT } from './SharedVariablesReferenceObject';
/**
 * This file is run at the project root to access initializeLibrary, so we are requiring the polyfills here.
 * Require used to avoid webpack treeshaking of import returning nothing.
 */

require('../polyfills');

var replaceObject = function replaceObject(reference, newObj) {
  Object.keys(reference).forEach(function (key) {
    // eslint-disable-next-line
    delete reference[key];
  });
  Object.keys(newObj).forEach(function (key) {
    // eslint-disable-next-line
    reference[key] = newObj[key];
  });
};

var replaceArray = function replaceArray(reference, array) {
  if (reference && array) reference.splice.apply(reference, [0, reference.length].concat(_toConsumableArray(array)));
};

var themeVariables = {
  onboarding: {
    TYPOGRAPHY: TYPOGRAPHY_BASE,
    BREAKPOINTS: BREAKPOINTS_BASE,
    BREAKPOINTS_EM: BREAKPOINTS_BASE_EM,
    BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY: BREAKPOINTS_BASE_EM_MIN_WIDTH_MEDIA_QUERY,
    DEFAULT_BREAKPOINTS_ASC: DEFAULT_BREAKPOINTS_ASC_BASE,
    MARGINS: MARGINS_BASE
  }
};

var loadThemeVariables = function loadThemeVariables(theme) {
  var _themeVariables$theme, _themeVariables$theme2, _themeVariables$theme3, _themeVariables$theme4, _themeVariables$theme5, _themeVariables$theme6;

  var themeId = theme || BASE_THEME_IDS.onboarding;
  var baseTheme = themeVariables.onboarding;
  replaceObject(SHARED_VARIABLES_REFERENCE_OBJECT.TYPOGRAPHY, ((_themeVariables$theme = themeVariables[themeId]) === null || _themeVariables$theme === void 0 ? void 0 : _themeVariables$theme.TYPOGRAPHY) || baseTheme.TYPOGRAPHY);
  replaceObject(SHARED_VARIABLES_REFERENCE_OBJECT.BREAKPOINTS, ((_themeVariables$theme2 = themeVariables[themeId]) === null || _themeVariables$theme2 === void 0 ? void 0 : _themeVariables$theme2.BREAKPOINTS) || baseTheme.BREAKPOINTS);
  replaceObject(SHARED_VARIABLES_REFERENCE_OBJECT.BREAKPOINTS_EM, ((_themeVariables$theme3 = themeVariables[themeId]) === null || _themeVariables$theme3 === void 0 ? void 0 : _themeVariables$theme3.BREAKPOINTS_EM) || baseTheme.BREAKPOINTS_EM);
  replaceObject(SHARED_VARIABLES_REFERENCE_OBJECT.BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY, ((_themeVariables$theme4 = themeVariables[themeId]) === null || _themeVariables$theme4 === void 0 ? void 0 : _themeVariables$theme4.BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY) || baseTheme.BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY);
  replaceArray(SHARED_VARIABLES_REFERENCE_OBJECT.DEFAULT_BREAKPOINTS_ASC, ((_themeVariables$theme5 = themeVariables[themeId]) === null || _themeVariables$theme5 === void 0 ? void 0 : _themeVariables$theme5.DEFAULT_BREAKPOINTS_ASC) || baseTheme.DEFAULT_BREAKPOINTS_ASC);
  replaceObject(SHARED_VARIABLES_REFERENCE_OBJECT.MARGINS, ((_themeVariables$theme6 = themeVariables[themeId]) === null || _themeVariables$theme6 === void 0 ? void 0 : _themeVariables$theme6.MARGINS) || baseTheme.MARGINS);
};

export var STORYBOOK_PARENT_THEME_RELOAD_QUERY_PARAM = 'storybook-parent-theme-reload-query-param';
var theme = queryParams[STORYBOOK_PARENT_THEME_RELOAD_QUERY_PARAM];
loadThemeVariables(theme || process.env.REACT_APP_THEME || 'onboarding'); // This function is invoked at the app root level in order for the code in this file to be loaded at the beginning on runtime. This is why the polyfills are also loaded in this file.
// eslint-disable-next-line

export var initializeLibrary = function initializeLibrary() {};